import React from 'react'

export const FooterPublic = () => {
    return (
        <footer className="bg-dark text-white ">

            {/* Logo */}
            <div className="max-w-6xl mx-auto px-4 pt-12 pb-6 text-center">
                <img 
                    src="assets/images/logo.jpg" 
                    className="rounded-full mx-auto" 
                    alt="Mémora" 
                    width="200"
                />
            </div>

            {/* ROW PRINCIPAL */}
<div className="max-w-4xl mx-auto px-16">
    <div className="flex justify-between items-start gap-6 ">

                    {/* IZQUIERDA (más grande) */}
                    <div className="flex-1 flex flex-col items-center text-left space-y-1">  
                        <div>
                            <a href="https://www.fundacionmemora.org/aviso-legal-fundacion" target="_blank" rel="noopener noreferrer" className="block hover:text-white">Aviso legal</a>
                            <a href="https://www.fundacionmemora.org/politica-privacidad-fundacion" target="_blank" rel="noopener noreferrer" className="block hover:text-white">Política de privacidad</a>
                            <a href="https://www.fundacionmemora.org/politica-cookies-fundacion" target="_blank" rel="noopener noreferrer"   className="block hover:text-white">Política de cookies</a>
                            <a 
                                href="https://www.memora.es/sites/default/files/uploads/Legal/PC%2019%20Canal%20de%20Denuncias%20de%20Irregularidades%20y%20Fraudes.pdf"
                                className="block hover:text-white"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Canal denuncias
                            </a>
                        </div>
                    </div>

                    {/* CENTRO */}
                    <div className="flex-1 flex items-center justify-center text-center">
                        <a href="mailto:fundacion@fundacionmemora.org" className="hover:text-white">
                            📧 fundacion@fundacionmemora.org
                        </a>
                    </div>

                    {/* DERECHA */}
                    <div className="flex-1 flex items-center justify-center text-right pr-16">
                        <div>
                            <a href="tel:900365240" className="hover:text-white">
                                📞 900 365 240
                            </a>
                        </div>
                    </div>

                </div>
            </div>

            {/* COPYRIGHT */}
            <div className="max-w-6xl mx-auto px-4 text-center py-4 border-t border-gray-700">
                <p className="text-gray-500 text-sm">
                    © 2026 Copyright Ciudadesquecuidan
                </p>
            </div>

        </footer>
    )
}